import { Coins } from '@/assets';
import { OptimizedPrismicImage } from '@/components';
import { Content } from '@prismicio/client';
import { Simplify } from '../../../../../../prismicio-types';
import { CardRange, CheckHomePage } from '../assets';
import styles from './homePageHeroCardsContent.module.scss';

export const HomePageHeroCardsContent = ({
  data,
  isVisible,
}: {
  data: Simplify<Content.HeroSliceDefaultPrimary>;
  isVisible: boolean;
}) => {
  const isVisibleCardStyle = isVisible ? styles.isVisible : '';

  return (
    <>
      <div className={`${styles.amount_card} ${isVisibleCardStyle}`}>
        <div className={styles.amount_text}>
          <span className={styles.heading}>{data.amount_heading}</span>
          <p className={styles.value}>{data.amound_value}</p>
        </div>
        <div className={styles.range}>
          <CardRange />
        </div>
      </div>
      <div className={`${styles.client_card} ${isVisibleCardStyle}`}>
        <div className={`${styles.image_wrapper} ${isVisibleCardStyle}`}>
          <OptimizedPrismicImage
            field={data.client_photo}
            className={styles.client_image}
          />
        </div>
        <div className={styles.check_icon}>
          <CheckHomePage />
        </div>
      </div>
      <div className={`${styles.offer_card} ${isVisibleCardStyle}`}>
        <ul className={styles.offer_list}>
          {data.offer_items.map((item) => (
            <li key={item.description}>
              <span className={styles.heading}>{item.description}</span>
              <p className={styles.value}>{item.value}</p>
            </li>
          ))}
        </ul>
        <Coins />
      </div>
    </>
  );
};
